<template>
    <v-container>
        <Datepicker1
            v-if="dateBegin"
            :dateInit="dateBegin"
            :eventName="evNameDtBegin"
            :monthEnable="false"
            />
        <PoiRegChart
            v-if="dateBegin"
            :tags="tags"
            :dateBegin="dateBegin"
            :dateEnd="dateEnd"
            />
    </v-container>
</template>

<script>
    import axios from "axios";
    import { EventBus } from "@/event-bus";
    import { requestTools } from "../mixins/requestTools.js";
    import { dateTimeTools } from "../mixins/dateTimeTools.js";
    import PoiRegChart from "./PoiRegChart";
    import Datepicker1 from "./Datepicker1";

    export default {
        name: "PoiRegHistReportByDay",

        components: {
            PoiRegChart,
            Datepicker1
        },

        props: {
            tags: String
        },

        mixins: [requestTools, dateTimeTools],

        data: function () {
            return {
                evNameDtBegin: "poiRegHistDateBeginChanged",
                dateBegin: "",
                dateEnd: ""
            };
        },

        created: function () {
            EventBus.$emit("eventPageLoad", {name: "Dados históricos do POI"});
            EventBus.$on(this.evNameDtBegin, (ev) => {
                this.dateBegin = ev.date + " 00:00:00";
                this.dateEnd = ev.date + " 23:59:50";
                this.resetDatepicker();
            });
            this.dateBegin = this.dateNow();
            this.dateEnd = this.dateNow();
        },

        filters: {
        },

        methods: {
            resetDatepicker() {
                const dateBegin = this.dateBegin;
                const dateEnd = this.dateEnd;

                this.dateBegin = "";
                this.dateEnd = "";

                setTimeout(() => {
                    this.dateBegin = dateBegin;
                    this.dateEnd = dateEnd;
                }, 1);
            }
        }
    };
</script>

<style>
    .main-card {
        margin-top:5px;
    }

    .ui-um {
        font-size: 10px;
    }
</style>
